module.exports = __webpack_public_path__ + "img/full6-min.8d5c6efc.png";